import * as React from 'react';

import {InfoIcon} from 'shells/icon/svg/info-icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './licensing.module.css';

type Props = {
    displayName: string;
    infoLink?: string | null | undefined;
};

export function SwitchName(props: Props) {
    return (
        <div className='flex align-center gap-4'>
            <Body isBold={true}>{props.displayName}</Body>
            {props.infoLink && (
                <Link variant='primary' size='small' newTab={true} href={props.infoLink}>
                    <InfoIcon size={24} alignCenter={true} className={styles['info-icon']} />
                </Link>
            )}
        </div>
    );
}
